import { usePageTitle } from "@/utilities";
import React from "react";
import {
  List,
  TextField,
  EmailField,
  EditButton,
  DateField,
  TextInput,
  Datagrid,
  useTranslate,
} from "react-admin";

const CashierList: React.FC = () => {
  const translate = useTranslate();
  usePageTitle(translate("ra.users.pageTitle"));

  const userFilters = [
    <TextInput source="q" label="ra.gameoo.searchPlaceholder" alwaysOn />,
  ];

  return (
    <List filters={userFilters} sort={{ field: "created_at", order: "DESC" }}>
      <Datagrid>
        <TextField source="full_name" label="ra.users.fullName" />
        <TextField source="pseudo" label="ra.users.pseudo" />
        <EmailField source="email" label="ra.users.mail" />
        <DateField
          source="created_at"
          label="ra.users.createdAt"
          options={{ year: "numeric", month: "long", day: "2-digit" }}
        />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default CashierList;
